module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "title",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTERS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITTEN AND")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENT")])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "title1"
  }, [_c('em', [_vm._v("poems")])]), _vm._v(" "), _c('p', {
    staticClass: "imagetp"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/tp.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUIS")]), _vm._v("-D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REYFUS")])]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "figure",
      "src": "images/pub.jpg"
    }
  }), _vm._v(" Red Hen Press | "), _c('em', [_vm._v("Pasadena, CA")])])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0d47ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 63
// module chunks = 0